const AuthErrorCodes = {
  PasswordExpired: 'password-expired',
  SSORedirect: 'x-deny',
  DefaultError: 'deny',
}

module.exports = {
  AuthErrorCodes,
}
